import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Map, GlobalContext } from 'commons';

const PolygonMap = ({ shapes }) => {
  const { lang, googleMapParam } = useContext(GlobalContext);

  return (
    <Map
      lang={lang}
      stroke
      googleMapParam={googleMapParam}
      paths={shapes.map(item => item.shape.points.map(point => ({ lat: point.y, lng: point.x })))}
    />
  );
};

PolygonMap.propTypes = {
  shapes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default PolygonMap;
